import * as React from "react";
const SvgAssisstance20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5.808 4.394A6.969 6.969 0 0 1 10 3a6.97 6.97 0 0 1 4.192 1.394l-2.16 2.16A3.982 3.982 0 0 0 10 6c-.742 0-1.436.202-2.032.554l-2.16-2.16ZM4.394 5.808A6.969 6.969 0 0 0 3 10c0 1.7.606 3.259 1.614 4.472l2.137-2.138A3.982 3.982 0 0 1 6 10c0-.742.202-1.436.554-2.032l-2.16-2.16ZM6.1 15.814l2.195-2.195A3.97 3.97 0 0 0 10 14a3.98 3.98 0 0 0 2.334-.751l2.138 2.137A6.972 6.972 0 0 1 10 17a6.967 6.967 0 0 1-3.9-1.186Zm9.714-1.914A6.967 6.967 0 0 0 17 10a6.969 6.969 0 0 0-1.394-4.192l-2.16 2.16c.352.596.554 1.29.554 2.032 0 .61-.136 1.188-.38 1.705l2.194 2.195ZM10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-2 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgAssisstance20Px;
